import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Stack } from "@financeable-com-au/financeable-ui";
import { BrandLogo } from "@components/BrandLogo";
import { authV2Selector, checkAuthV2Session } from "@/store/slices/authV2Slice";
import { ROUTES } from "@/constants";

const AuthLayout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { session } = useSelector(authV2Selector);
  const searchParams = new URLSearchParams(location.search);
  const invitationToken = searchParams.get("invitationToken") ?? searchParams.get("invitation_token") ?? searchParams.get("token");
  const isInviteAcceptPath =
    location.pathname === `${ROUTES.AUTH.ROOT}/${ROUTES.AUTH.INVITE.ROOT}/${ROUTES.AUTH.INVITE.ACCEPT}`;
  const canCompleteInvite = Boolean(invitationToken) && isInviteAcceptPath;

  // /auth/* is in publicRoutes, so the route-level auth check in routes.jsx
  // skips it. Run the session check here so reloads on the sign-in page can
  // detect an existing WorkOS session and redirect away.
  useEffect(() => {
    dispatch(checkAuthV2Session());
  }, []);

  if (!session.checked) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ minHeight: "100vh" }}>
        <CircularProgress />
      </Stack>
    );
  }

  if ((session.authenticated || sessionStorage.token) && !canCompleteInvite) {
    return <Navigate to={`/${ROUTES.APP.APPLICATIONS}`} replace />;
  }

  return (
    <Stack
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      rowGap={6}
      bgcolor="neutral.100"
    >
      <BrandLogo />
      <Outlet />
    </Stack>
  );
};

export { AuthLayout };
